
import { defineComponent, PropType } from 'vue'

// types
import { InvoiceNewServicesT } from '@/core/types/orders.types'

export default defineComponent({
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Доп. услуги',
        },
        key: {
            type: String,
            default: 'Service',
        },
        services: {
            type: Object as PropType<InvoiceNewServicesT>,
            default: null,
        },
    },
})
